import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "picker-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "item-title" }

import { ConditionViewModel } from './models/conditionViewModel';
import { ConditionPickerOption } from './models/conditions';
import Icon from '@/shared/icons/Icon.vue';
import { Icons } from '@/shared/icons/icons';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionPicker',
  props: {
  availableConditions: {
    type: Array as PropType<ConditionPickerOption[]>,
    required: true,
  },
},
  emits: ["selected"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

function getIconComponent(option: ConditionPickerOption): keyof typeof Icons {
  if (option && option.icon) {
    return option.icon;
  }

  return 'CustomAttributeIcon';
}

function chooseOption(option: ConditionPickerOption) {
  const condition: ConditionViewModel = {
    attribute: option.id,
    operation: '',
    type: option.type,
    unit: '',
    value: '',
    result: true,
  };

  emit('selected', condition);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableConditions, (option) => {
        return (_openBlock(), _createElementBlock("a", {
          onClick: ($event: any) => (chooseOption(option)),
          class: "dropdown-item",
          key: option.id
        }, [
          _createVNode(Icon, {
            icon: getIconComponent(option)
          }, null, 8, ["icon"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(option.title), 1)
        ], 8, _hoisted_2))
      }), 128))
    ])
  ]))
}
}

})